<nz-page-header (nzBack)="goBack()" nzBackIcon nzTitle="Organization Detail">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item><a routerLink="/organization">Organizations</a></nz-breadcrumb-item>
    <nz-breadcrumb-item>{{ organization?.name ?? 'org-detail' }}</nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-page-header-extra>
    <button nz-button nzType="primary" (click)="openInvitationModal()">
      <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
      {{ 'add_user' | translate }}
    </button>
  </nz-page-header-extra>
</nz-page-header>
<!--<div>-->
<!--  <button nz-button nzType="dashed" [nzSize]="'large'" (click)="goBack()">-->
<!--    <nz-icon nzType="left" nzTheme="outline"/>-->
<!--  </button>-->
<!--</div>-->
@if (organization) {
  <nz-divider [nzText]="organization.name"></nz-divider>
  <nz-descriptions [nzColumn]="1" [nzSize]="'small'" nzBordered>
    <nz-descriptions-item nzTitle="Name">{{ organization.name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Email">{{ organization.email }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Phone">{{ organization.phone }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Adress">{{ organization.address }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="ID">{{ organization.id }}</nz-descriptions-item>
  </nz-descriptions>
  <nz-divider nzText="B2C referrals"></nz-divider>
  @if (referral) {
    <div class="flex flex-col gap-2">
      <div>Organization active: <b>{{referral.is_active ? 'Yes' : 'No'}}</b></div>
      <div>Referrals enabled: <b>{{referral.referral_enabled ? 'Yes' : 'No'}}</b></div>
      <div>Partner code: <b>{{referral.partner_code || '-'}}</b></div>
      <div>Canonical Branch URL: <a [href]="referral.link?.branch_url" target="_blank">{{referral.link?.branch_url || '-'}}</a></div>
      <div class="flex gap-2">
        <button nz-button (click)="updateReferral(!referral.is_active, referral.referral_enabled)">{{referral.is_active ? 'Deactivate Organization' : 'Activate Organization'}}</button>
        <button nz-button (click)="updateReferral(referral.is_active, !referral.referral_enabled)">{{referral.referral_enabled ? 'Disable referrals' : 'Enable referrals'}}</button>
        <button nz-button nzType="primary" (click)="rotateReferral()">{{referral.link ? 'Rotate link' : 'Create link'}}</button>
        <button nz-button nzDanger [disabled]="!referral.link" (click)="revokeReferral()">Revoke link</button>
      </div>
      <div>Opens {{referral.funnel?.opens || 0}} · Started {{referral.funnel?.registration_started || 0}} · Completed {{referral.funnel?.completed || 0}}</div>
    </div>
  }
  <div class="flex gap-3 w-full mt-3 usersTable">
    <nz-table #basicTable [nzData]="orgInvitedUsers" class="w-full" nzTitle="Invited Users" nzNoResult="No Data">
      <thead>
      <tr>
        <th>Email</th>
        <th>Role</th>
        <th>Date</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
        @for(data of basicTable.data; track data) {
          <tr>
            <td>{{data.email}}</td>
            <td>{{data.role}}</td>
            <td>{{data.date}}</td>
            <td><nz-tag [nzColor]="data.status === 1 ? 'processing' : 'success'">{{ data.status === 1 ? 'In Progress' : 'Completed' }}</nz-tag></td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-table #registeredTable [nzData]="orgRegisteredUsers" class="w-full" nzTitle="Registered Users" nzNoResult="No Data">
      <thead>
      <tr>
        <th>Email</th>
        <th>Role</th>
        <th>Date</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
        @for(data of registeredTable.data; track data) {
          <tr>
            <td>{{data.email}}</td>
            <td>{{data.role}}</td>
            <td>{{data.date}}</td>
            <td><nz-tag [nzColor]="data.status === 1 ? 'processing' : 'success'">{{ data.status === 1 ? 'In Progress' : 'Completed' }}</nz-tag></td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
} @else {
  <nz-spin nzSimple nzSize="large"></nz-spin>
}

<nz-modal
  [(nzVisible)]="addUserModalVisible"
  nzTitle="Modal Title"
  (nzOnCancel)="cancelUserAdd()"
  (nzOnOk)="addUser()"
  [nzOkLoading]="loading"
  [nzOkText]="'Add'"
  [nzCancelText]="'Cancel'"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="newUserForm" class="login-form" (ngSubmit)="addUser()">
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your E-mail!">
          <nz-input-group>
            <input type="email" nz-input formControlName="email" placeholder="Enter Email"/>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input user Role!">
          <nz-select formControlName="role" nzPlaceHolder="Select a role">
            @for(item of roles; track item) {
              <nz-option [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
